import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import { AiOutlineTwitter } from "react-icons/ai"
import { signInWithTwitter } from '../../../helper/helper';
import { Alert, Snackbar } from '@mui/material';
import { useDispatch } from 'react-redux';
import { LOGIN } from '../../../Redux/actions/actions';

const emails = ['username@gmail.com', 'user02@gmail.com'];

export default function SimpleDialog(props) {
  const dispatch = useDispatch()
  const { onClose, open } = props;
  const [openAlert, setOpenAlert] = React.useState(false)
  const [openError, setOpenError] = React.useState(false)
  const [response, setResponse] = React.useState(false)
  const handleClose = () => {
    onClose();
  };

  const handleLogin = async() => {
    try {
      let response = await signInWithTwitter(handleClose)
      console.log(response)
      if (response.ok) {
        dispatch(LOGIN(response))
        setOpenAlert(true)
      } else {
        setOpenError(true)
      }
    } catch(e){
      console.log(e)
    }
  }
  const handleListItemClick = (value) => {
    onClose(value);
  };
  let style = {
    backgroundColor: "#00b9ff",
    border: "none",
    color: "#fff",
    padding: "1em 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1em",
    cursor: "pointer",
  }
  let styleBtn = {
    backgroundColor: "#00b9ff",
    border: "none",
    color: "#fff",
    padding: "1em 0",
    fontSize: "1rem"
  }

  return (
    <>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>Log in with Twitter</DialogTitle>
        <div onClick={() => handleLogin()} style={style}>
          <button style={styleBtn}>Continue</button>
          <AiOutlineTwitter size={"1.5em"} />
        </div>
      </Dialog>
      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={openAlert} autoHideDuration={5000} onClose={() => setOpenAlert(false)}>
        <Alert onClose={() => setOpenAlert(false)} severity="success" sx={{ width: '100%' }}>
          Log in Succesfully!
        </Alert>
      </Snackbar>
      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={openError} autoHideDuration={3000} onClose={() => setOpenError(false)}>
        <Alert onClose={() => setOpenError(false)} severity="error" sx={{ width: '100%' }}>
        Login Failed, please try later!
        </Alert>
      </Snackbar>
    </>
  );
}

// SimpleDialog.propTypes = {
//   onClose: PropTypes.func.isRequired,
//   open: PropTypes.bool.isRequired,
//   selectedValue: PropTypes.string.isRequired,
// };
